<script lang="ts">
import { defineComponent } from 'vue'

// eslint-disable-next-line no-restricted-syntax
export enum ChipVariant {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  UNDERLINED = 'underlined',
  GHOST = 'ghost',
}

export default defineComponent({
  name: 'SancareChip',
})
</script>

<script lang="ts" setup>
import SancareOcticon from './SancareOcticon.vue'
export interface SancareChipProps {
  icon?: string | null
  isClickable?: boolean
  isDisabled?: boolean
  iconEnd?: string | null
  isIconEndHidden?: boolean
  isLoading?: boolean
  label?: string | null
  text: string
  variant?: ChipVariant
}

const props = withDefaults(defineProps<SancareChipProps>(), {
  icon: null,
  isClickable: true,
  isDisabled: false,
  iconEnd: null,
  isIconEndHidden: false,
  isLoading: false,
  label: null,
  variant: ChipVariant.FILLED,
})

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'clickOnIcon'): void
}>()


function handleClick(): void {
  if (!props.isDisabled && !props.isLoading && props.isClickable) {
    emit('click')
  }
}

function handleClickOnIcon(): void {
  emit('clickOnIcon')
}
</script>

<template>
  <div
    class="sancare-chip d-inline-flex justify-content-center align-items-center"
    :class="[
      {
        'sancare-chip--disabled': isDisabled,
        'sancare-chip--underlined': variant === ChipVariant.UNDERLINED,
        'sancare-chip--filled': variant === ChipVariant.FILLED,
        'sancare-chip--outlined': variant === ChipVariant.OUTLINED,
        'sancare-chip--ghost': variant === ChipVariant.GHOST,
        'sancare-chip--clickable': !isLoading && isClickable,
      },
    ]"
    @click="handleClick"
  >
    <div class="sancare-chip__content">
      <sancare-octicon
        v-if="icon"
        :width="12"
        :name="icon"
        class="sancare-chip__content__icon"
        :class="[
          {
            'sancare-chip__content__icon--disabled': isDisabled,
            'sancare-chip__content__icon--filled': variant === ChipVariant.FILLED,
          },
        ]"
      />
      <span
        v-if="label"
        class="sancare-chip__content__label"
      >
        {{ label }}
      </span>
      <span
        class="sancare-chip__content__text"
        :class="{ 'sancare-chip__content__text--underlined': variant === ChipVariant.UNDERLINED }"
      >
        {{ text }}
      </span>
    </div>
    <div
      v-if="isLoading || iconEnd"
      class="sancare-chip__icon-end"
      :class="{'sancare-chip__icon-end__hidden': isIconEndHidden}"
      @click="handleClickOnIcon"
    >
      <span
        v-if="isLoading"
        class="loader loader-xs m-0"
      />
      <sancare-octicon
        v-else
        :width="12"
        :name="iconEnd"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loader-xs {
  width: 12px;
  height: 12px;
}
</style>
